module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('md-toolbar', {
    staticClass: "md-whiteframe main-header  md-whiteframe-1dp"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.toggleLeftSidenav($event)
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-hide-small": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png")
    }
  })])], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    attrs: {
      "md-swipeable": true
    }
  }, [_c('md-toolbar', {
    staticClass: "md-small"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-avatar', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentUser.photoURL,
      "alt": "Avatar"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "md-title nickname"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.displayName) + " ")])], 1)]), _vm._v(" "), (_vm.currentFluxer[0]) ? _c('md-list', [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "proceso"
    }
  }, [_c('md-icon', [_vm._v("question_answer")]), _vm._v(" "), _c('span', [_vm._v("Proceso de Feedback")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('md-icon', [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('span', [_vm._v("Feedback a Fluxers")])], 1)], 1), _vm._v(" "), (_vm.currentFluxer[0].lider) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/acuerdo-objetivos"
    }
  }, [_c('md-icon', [_vm._v("playlist_add_check")]), _vm._v(" "), _c('span', [_vm._v("Acuerdo De Objetivos")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/mis-objetivos"
    }
  }, [_c('md-icon', [_vm._v("playlist_add_check")]), _vm._v(" "), _c('span', [_vm._v("Mis Objetivos")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/mis-meritos"
    }
  }, [_c('md-icon'), _vm._v(" "), _c('span', [_vm._v("Mis Meritos")])], 1)], 1), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/admin-mis-meritos"
    }
  }, [_c('md-icon'), _vm._v(" "), _c('span', [_vm._v("Administrar Mis Meritos")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/reporte-feedbacks"
    }
  }, [_c('md-icon', [_vm._v("assessment")]), _vm._v(" "), _c('span', [_vm._v("Reporte de Feedbacks")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/reporte-objetivos"
    }
  }, [_c('md-icon', [_vm._v("assessment")]), _vm._v(" "), _c('span', [_vm._v("Reporte de Objetivos")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")]), _vm._v(" "), _c('span', [_vm._v("Salir")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2311f5df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 374
// module chunks = 1